import {dbComun} from '../bases-datos'

export const ObtenerTiposExamen = async () => {
  return Promise.resolve(dbComun.table('TiposExamen').toArray())
}
